export const config = {
  title: "Agility Pro Painting | Quality Painting Services in Manchester, NJ",
  meta: {
    description:
      "Agility Pro Painting provides top-quality residential and commercial painting services throughout Manchester, NJ and surrounding areas.",
    keywords: [
      "Agility Pro Painting",
      "Manchester NJ painting services",
      "residential painting New Jersey",
      "commercial painting Manchester",
      "interior exterior painters NJ"
    ],
    author: "Agility Pro Painting",
    canonicalUrl: "https://www.agilitypro-painting.com/",
  },
  sections: {
    header: {
      businessName: "Agility Pro Painting",
    },
    sectionB: {
      heroTitle: "Agility Pro Painting",
      heroSubtitle: "Precision Painting for Homes & Businesses in Manchester, NJ",
      learnAboutText: "Request a Quote",
      phoneNumber: "2019264491",
      phoneLabel: "(201) 926-4491",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1461683093/photo/man-painting-wall-with-light-blue-dye-indoors-back-view.jpg?s=612x612&w=0&k=20&c=TDg87xVDJh-VA4zVClGlMnqpdqTh2QcZ--raihCv9XU=",
      cardData: [
        {
          title: "Interior Painting",
          description: "Transform your home's interior with clean, professional finishes.",
        },
        {
          title: "Exterior Painting",
          description: "Durable and weather-resistant exterior painting for curb appeal.",
        },
        {
          title: "Residential & Commercial",
          description: "Expert service for both home and business spaces.",
        },
      ],
      description:
        "Agility Pro Painting is a trusted local painting company offering detailed, professional painting services across Manchester and the surrounding regions. We focus on precision, quality, and customer satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We provide comprehensive painting solutions tailored to your needs, ensuring long-lasting results and a vibrant finish.",
      cards: [
        {
          title: "Interior Painting",
          description: "Beautiful and precise finishes for living rooms, kitchens, and more.",
          imageSrc: "https://media.istockphoto.com/id/2190057704/photo/man-painting-living-room-wall-during-apartment-renovation.jpg?s=612x612&w=0&k=20&c=YdjDxlzP_PRNjX_yERTALgepZALghon-9H4PUF52ygw=",
          imageAlt: "Interior Painting",
        },
        {
          title: "Exterior Painting",
          description: "Protect and enhance your home's exterior with durable paintwork.",
          imageSrc: "https://media.istockphoto.com/id/176882062/photo/painter-working-at-roofline.jpg?s=612x612&w=0&k=20&c=ThyFPXfjLyxM4yBEENMVQoXA9ofKg-sDCBs10RIdVos=",
          imageAlt: "Exterior Painting",
        },
        {
          title: "Commercial Spaces",
          description: "Clean and efficient painting for offices, stores, and buildings.",
          imageSrc: "https://media.istockphoto.com/id/2161507261/photo/a-professional-house-painters-painting-an-apartment.jpg?s=612x612&w=0&k=20&c=23syAvxJUCVG_vug99OBXq5ew2-R5H95FCgXgbJlxhU=",
          imageAlt: "Commercial Painting",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Experienced Painting Team",
        "Free Estimates",
        "Detail-Oriented Work",
        "Premium-Grade Materials",
        "Customer Satisfaction Guaranteed"
      ],
    },
    sectionD: {
      aboutTitle: "About Agility Pro Painting",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2221468674/photo/painting-an-exterior-wall-with-a-white-paint-roller-brush-outdoor-home-renovation-concept.jpg?s=612x612&w=0&k=20&c=jlB1fuHslW8e5ZvC3tDOjDBdl6YJapHLntHR-ViPhTA=",
        alt: "Agility Pro Painting Team",
      },
      aboutText: [
        "Agility Pro Painting is dedicated to enhancing homes and businesses with professional painting services. Our team ensures attention to detail, quality products, and long-lasting results.",
        "Located in Manchester, NJ, we proudly serve homeowners and businesses throughout the region."
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Agility Pro Painting Logo",
      businessName: "Agility Pro Painting",
      contact: {
        phone: "2019264491",
        phoneLabel: "(201) 926-4491",
        email: "agilitypro1983@gmail.com",
        website: "https://www.agilitypro-painting.com/",
        address: "Manchester, New Jersey, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Manchester, New Jersey, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3045.6548617430724!2d-74.3735!3d39.9671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c1866c57cc3d5f%3A0x36f4b6c7cf92e2de!2sManchester%2C%20NJ!5e0!3m2!1sen!2sus!4v1710000000000",
    },
  },
};

export default config;
